import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'
import Tooltip, { Align, TooltipProps } from 'core/elements/tooltip/Tooltip'
import useListAction from 'core/hooks/useListAction'
import { listClusterHostGroupsAllTenants } from './actions'
import { clusterHostGroupsAllTenantsSelectorSimple } from './selectors'

interface Props {
  label?: string
  width?: number
  fullWidth?: boolean
  tooltip?: string
  tooltipProps?: TooltipProps
  includeNone?: boolean
  includeAllOption?: boolean
  disableClusterWithoutHosts?: boolean
  filterFn?: (item: any) => boolean
  compact?: boolean
  labelPosition?: 'top' | 'left'
}

export default function ClusterHostGroupsPicklist({
  width = 180,
  fullWidth = false,
  label,
  tooltip = '',
  tooltipProps,
  includeNone = false,
  includeAllOption = false,
  compact = true,
  onChange,
  value,
  disabled = false,
  labelPosition = 'top',
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const { loading } = useListAction(listClusterHostGroupsAllTenants)
  const clusterHostGroups = useSelector(clusterHostGroupsAllTenantsSelectorSimple)

  const items = useMemo(() => {
    const options = clusterHostGroups?.map((clusterHostGroup) => {
      return {
        label: clusterHostGroup.name,
        value: clusterHostGroup.name,
      }
    })

    const result = []
    if (includeAllOption) {
      result.push({
        label: 'All',
        value: 'all',
      })
    }
    if (includeNone) {
      result.push({
        label: '-- None --',
        value: '',
      })
    }
    return [...result, ...options]
  }, [clusterHostGroups, includeNone, includeAllOption])

  return compact ? (
    <AsyncDropdown
      name={label}
      label={label}
      items={items}
      formField
      // loading={loading}
      width={fullWidth ? undefined : width}
      {...rest}
    />
  ) : (
    <GlobalDropdownWithSearch
      label={label}
      items={items}
      loading={loading}
      onChange={(item) => onChange(item.value)}
      value={value}
      {...(labelPosition === 'left' ? { showLabelOnLeft: true } : { showLabelOnTop: true })}
      align={'left'}
      disabled={disabled}
      width={width}
    />
  )
}
